"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("core-js/modules/es6.regexp.split");
require("core-js/modules/es6.function.name");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.number.constructor");
var _popupConfig = require("@/api/popup/popupConfig.js");
var _popupTypes = require("@/utils/popupTypes.js");
var _memberManagement = require("@/api/member/memberManagement");
var _gradeInfo = require("@/api/basic/gradeInfo");
var _request = _interopRequireDefault(require("@/utils/request.js"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'OrderHomePopupForm',
  props: {
    // 编辑ID（从路由或父组件传入）
    editId: {
      type: [Number, String],
      default: null
    },
    // 是否为编辑模式
    isEdit: {
      type: Boolean,
      default: false
    },
    // 弹窗类型（菜单页或首页）
    popupType: {
      type: Number,
      default: 2 // 默认为首页弹窗
    }
  },
  data: function data() {
    return {
      formData: {
        title: '',
        recommendType: 1,
        sendScene: [],
        isVip: 1,
        vipGrade: [],
        isAddQy: 1,
        isSaleOrder: 1,
        isNewPeopleCoupon: 1,
        userType: 1,
        showImage: null,
        dateRange: [],
        recommendContent: '',
        recommendContentSub: null,
        recommendContentId: null,
        recommendContentParam: null,
        recommendPriority: 0,
        showPlatform: [1],
        isEnable: true,
        isShow: true,
        remark: '',
        vipGradeRadio: null,
        // 分组类型相关字段
        cdpGrpType: 0,
        cdpGrpId: null,
        // 滑屏相关字段
        sliderBackgroundColor: '',
        sliderTextColor: '',
        sliderLoadColor: '',
        sliderScheme: '',
        sliderImage: ''
      },
      allPage: [],
      // 图片资源前缀
      imagePrefix: '',
      // 等级相关数据
      vipGrades: [],
      fileList: [],
      // 照片墙文件列表
      previewVisible: false,
      // 预览对话框显示状态
      previewImageUrl: '',
      // 预览图片URL
      // 滑屏图片相关
      sliderImageList: [],
      // 滑屏图片文件列表
      sliderPreviewVisible: false,
      // 滑屏图片预览对话框显示状态
      sliderPreviewImageUrl: '',
      // 滑屏图片预览URL
      // 页面列表数据
      pageList: [],
      // CDP分组相关数据
      cdpGroupOptions: [],
      cdpGroupLoading: false,
      rules: {
        title: [{
          required: true,
          message: '请输入标题',
          trigger: 'blur'
        }],
        recommendType: [{
          required: true,
          message: '请选择推荐类型',
          trigger: 'change'
        }]
      },
      // 调查问卷模拟数据选项
      surveyOptions: []
    };
  },
  watch: {
    // 监听编辑ID变化并拉取详情
    editId: {
      handler: function handler(newId) {
        if (newId) {
          this.fetchDetailById(newId);
        }
      },
      immediate: true
    }
  },
  mounted: function mounted() {
    // 组件挂载后获取等级列表和图片前缀
    this.getVipGradeList();
    this.getImagePrefix();
    // 获取页面列表
    this.getPageList();
  },
  methods: {
    // 外部小程序类型(社区/其他)切换时清空后续输入框
    changeRecommendContentSub: function changeRecommendContentSub() {
      this.formData.recommendContent = '';
      this.formData.recommendContentId = '';
      this.formData.recommendContentParam = '';
    },
    changeRecommendInfo: function changeRecommendInfo() {
      this.formData.recommendContent = '';
      this.formData.recommendContentId = '';
      this.formData.recommendContentParam = '';
      if (this.formData.recommendType == 3) {
        this.pageList = this.allPage.filter(function (item) {
          return item.appid === 'GAGAX' || item.appid === 'DELI';
        });
      } else if (this.formData.recommendType == 6) {
        this.pageList = this.allPage.filter(function (item) {
          return item.appid === 'GAGAS';
        });
      }
    },
    // 获取会员等级列表
    getVipGradeList: function () {
      var _getVipGradeList = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var response, _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              this.gradeLoading = true;
              _context.next = 1;
              return (0, _gradeInfo.xyRuleVipGradeSelPage)({
                page: 1,
                limit: 100 // 获取所有等级，如果等级很多可以分页
              });
            case 1:
              response = _context.sent;
              if (response.code === 200 && response.records) {
                this.vipGrades = response.records.map(function (grade) {
                  return {
                    id: grade.id,
                    name: grade.name,
                    levelId: grade.levelId
                  };
                });
                console.log('获取等级列表成功：', this.vipGrades);
              } else {
                this.$message.error('获取等级列表失败');
              }
              _context.next = 3;
              break;
            case 2:
              _context.prev = 2;
              _t = _context["catch"](0);
              console.error('获取等级列表错误：', _t);
              this.$message.error('获取等级列表失败');
            case 3:
              _context.prev = 3;
              this.gradeLoading = false;
              return _context.finish(3);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 2, 3, 4]]);
      }));
      function getVipGradeList() {
        return _getVipGradeList.apply(this, arguments);
      }
      return getVipGradeList;
    }(),
    // 获取图片资源前缀
    getImagePrefix: function () {
      var _getImagePrefix2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var response, _t2;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 1;
              return (0, _memberManagement.getImagePrefix)();
            case 1:
              response = _context2.sent;
              console.log('获取图片前缀响应：', response);
              if (response.code === 200) {
                this.imagePrefix = response.data;
                console.log('获取图片前缀成功：', this.imagePrefix);
              } else {
                console.error('获取图片前缀失败：', response.message);
              }
              _context2.next = 3;
              break;
            case 2:
              _context2.prev = 2;
              _t2 = _context2["catch"](0);
              console.error('获取图片前缀错误：', _t2);
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function getImagePrefix() {
        return _getImagePrefix2.apply(this, arguments);
      }
      return getImagePrefix;
    }(),
    // 通过ID获取详情
    fetchDetailById: function fetchDetailById(id) {
      var _this = this;
      (0, _popupConfig.getPopupInfo)(id).then(function (res) {
        var data = res && (res.data || res.xyPopUp || res); // 兼容不同返回包装
        if (data) {
          _this.initFormData(data);
        }
      }).catch(function (err) {
        console.error('获取详情失败:', err);
        _this.$message.error('获取详情失败');
      });
    },
    // 初始化表单数据
    initFormData: function initFormData(data) {
      if (!data) return;

      // 映射列表数据到表单数据
      this.formData = {
        title: data.title || '',
        recommendType: Number(data.recommendType) || 1,
        sendScene: data.sendScene ? data.sendScene.split(',').map(function (v) {
          return Number(v);
        }) : [],
        isVip: Number(data.isVip) || 1,
        vipGrade: data.vipGrade ? data.vipGrade.split(',').map(function (v) {
          return Number(v);
        }) : [],
        isAddQy: Number(data.isAddQy) || 1,
        isSaleOrder: Number(data.isSaleOrder) || 1,
        isNewPeopleCoupon: Number(data.isNewPeopleCoupon) || 1,
        userType: Number(data.userType) || 1,
        showImage: data.showImage,
        dateRange: this.formatTimestampToRange(data.showStartTime, data.showEndTime),
        recommendContent: data.recommendContent || '',
        recommendContentId: data.recommendContentId != null ? String(data.recommendContentId) : null,
        recommendContentParam: data.recommendContentParam || null,
        recommendPriority: Number(data.recommendPriority) || 0,
        showPlatform: data.showPlatform ? data.showPlatform.split(',').map(function (v) {
          return Number(v);
        }) : [1],
        isEnable: data.isEnable !== undefined ? data.isEnable : true,
        isShow: data.isShow !== undefined ? data.isShow : true,
        remark: '',
        vipGradeRadio: Number(data.vipGradeRadio) || null,
        // 分组类型相关字段
        cdpGrpType: Number(data.cdpGrpType) || 0,
        cdpGrpId: data.cdpGrpId,
        // 滑屏相关字段
        sliderBackgroundColor: data.sliderBackgroundColor,
        sliderTextColor: data.sliderTextColor,
        sliderLoadColor: data.sliderLoadColor,
        sliderScheme: data.sliderScheme,
        sliderImage: data.sliderImage,
        recommendContentSub: data.recommendContentSub || ''
      };
      // 如果有图片，初始化文件列表
      if (this.formData.showImage) {
        this.fileList = [{
          name: '图片',
          url: this.formData.showImage,
          uid: Date.now()
        }];
      }

      // 如果有滑屏图片，初始化滑屏图片文件列表
      if (this.formData.sliderImage) {
        this.sliderImageList = [{
          name: '滑屏图片',
          url: this.formData.sliderImage,
          uid: Date.now()
        }];
      }
      if (this.formData.recommendType == 3) {
        this.pageList = this.allPage.filter(function (item) {
          return item.appid === 'GAGAX' || item.appid === 'DELI';
        });
      } else if (this.formData.recommendType == 6) {
        this.pageList = this.allPage.filter(function (item) {
          return item.appid === 'GAGAS';
        });
      }
    },
    // 将时间戳转换为日期范围数组
    formatTimestampToRange: function formatTimestampToRange(startTime, endTime) {
      if (!startTime || !endTime) return [];

      // 将时间戳转换为Date对象
      var startDate = new Date(startTime);
      var endDate = new Date(endTime);
      return [startDate, endDate];
    },
    // 格式化日期时间为Java后端可识别的格式
    formatDateTime: function formatDateTime(date) {
      if (!date) return null;

      // 统一返回时间戳
      if (date instanceof Date) {
        return date.getTime();
      }

      // 如果是字符串，先转换为Date再取时间戳
      if (typeof date === 'string') {
        return new Date(date).getTime();
      }
      return date;
    },
    // 处理图片选择
    handleImageChange: function handleImageChange(file, fileList) {
      var _this2 = this;
      if (file.status === 'ready') {
        // 本地预览
        var reader = new FileReader();
        reader.onload = function (e) {
          file.url = e.target.result;
          _this2.fileList = [_objectSpread({}, file)];
        };
        reader.readAsDataURL(file.raw);

        // 开始上传
        (0, _popupConfig.uploadPopupImage)(file.raw).then(function (res) {
          var url = res && res.data || res;
          if (!url) {
            _this2.$message.error('上传失败');
            return;
          }
          // 设置为返回的URL
          _this2.formData.showImage = url;
          // 更新fileList中的展示URL
          _this2.fileList = [{
            name: file.name,
            url: url,
            uid: file.uid
          }];
          _this2.$message.success('图片上传成功');
        }).catch(function (err) {
          console.error('图片上传失败:', err);
          _this2.$message.error('图片上传失败');
          _this2.fileList = [];
          _this2.formData.showImage = null;
        });
      }
    },
    // 处理图片移除
    handleImageRemove: function handleImageRemove(file) {
      this.fileList = [];
      this.formData.showImage = null;
    },
    // 处理图片预览
    handleImagePreview: function handleImagePreview(file) {
      this.previewImageUrl = file.url;
      this.previewVisible = true;
    },
    // 处理超出限制
    handleExceed: function handleExceed(files, fileList) {
      this.$message.warning('只能上传一张图片!');
    },
    // 图片上传前验证
    beforeImageUpload: function beforeImageUpload(file) {
      var isImage = file.type.indexOf('image/') === 0;
      if (!isImage) {
        this.$message.error('只能上传图片文件!');
        return false;
      }
      if (file.size / 1024 / 1024 > 2) {
        this.$message.error('图片大小不能超过 2MB!');
        return false;
      }
      return false; // 阻止自动上传
    },
    // 处理滑屏图片选择
    handleSliderImageChange: function handleSliderImageChange(file, fileList) {
      var _this3 = this;
      if (file.status === 'ready') {
        // 本地预览
        var reader = new FileReader();
        reader.onload = function (e) {
          file.url = e.target.result;
          _this3.sliderImageList = [_objectSpread({}, file)];
        };
        reader.readAsDataURL(file.raw);

        // 开始上传
        (0, _popupConfig.uploadPopupImage)(file.raw).then(function (res) {
          var url = res && res.data || res;
          if (!url) {
            _this3.$message.error('上传失败');
            return;
          }
          // 设置为返回的URL
          _this3.formData.sliderImage = url;
          // 更新sliderImageList中的展示URL
          _this3.sliderImageList = [{
            name: file.name,
            url: url,
            uid: file.uid
          }];
          _this3.$message.success('图片上传成功');
        }).catch(function (err) {
          console.error('图片上传失败:', err);
          _this3.$message.error('图片上传失败');
          _this3.sliderImageList = [];
          _this3.formData.sliderImage = null;
        });
      }
    },
    // 处理滑屏图片移除
    handleSliderImageRemove: function handleSliderImageRemove(file) {
      this.sliderImageList = [];
      this.formData.sliderImage = null;
    },
    // 处理滑屏图片预览
    handleSliderImagePreview: function handleSliderImagePreview(file) {
      this.sliderPreviewImageUrl = file.url;
      this.sliderPreviewVisible = true;
    },
    // 获取页面列表
    getPageList: function () {
      var _getPageList = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var response, _t3;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 1;
              return (0, _popupConfig.queryPageList)();
            case 1:
              response = _context3.sent;
              if (response.code === 200 && response.data) {
                // 将返回的页面数据转换为下拉选项格式
                this.allPage = response.data.map(function (item) {
                  return {
                    value: item.pageUrl,
                    label: item.pageName,
                    appid: item.appid,
                    id: String(item.id)
                  };
                });
                this.pageList = this.allPage;
                if (this.formData.recommendType == 3) {
                  this.pageList = this.allPage.filter(function (item) {
                    return item.appid === 'GAGAX' || item.appid === 'DELI';
                  });
                } else if (this.formData.recommendType == 6) {
                  this.pageList = this.allPage.filter(function (item) {
                    return item.appid === 'GAGAS';
                  });
                }
              } else {
                console.error('获取页面列表失败：', response.message);
              }
              _context3.next = 3;
              break;
            case 2:
              _context3.prev = 2;
              _t3 = _context3["catch"](0);
              console.error('获取页面列表错误：', _t3);
              this.$message.error('获取页面列表失败');
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[0, 2]]);
      }));
      function getPageList() {
        return _getPageList.apply(this, arguments);
      }
      return getPageList;
    }(),
    // 提交表单
    handleSubmit: function handleSubmit() {
      var _this4 = this;
      this.$refs.orderHomeForm.validate(function (valid) {
        if (valid) {
          // 社区模式：清理"其他"模式遗留的appid（recommendContentId 必须是选中的页面ID）
          if (_this4.formData.recommendType == 6 && _this4.formData.recommendContentSub == 'GAGAS') {
            if (!_this4.pageList.some(function (p) {
              return p.id === _this4.formData.recommendContentId;
            })) {
              _this4.formData.recommendContentId = '';
            }
            _this4.formData.recommendContent = '';
          }

          // 构造要提交的数据
          var submitData = {
            id: _this4.isEdit && _this4.editId ? _this4.editId : null,
            title: _this4.formData.title,
            recommendType: _this4.formData.recommendType,
            recommendContent: _this4.formData.recommendContent,
            recommendContentId: _this4.formData.recommendContentId,
            recommendContentParam: _this4.formData.recommendContentParam,
            recommendPriority: _this4.formData.recommendPriority || 0,
            popType: _this4.popupType,
            // 动态设置弹窗类型
            sendScene: (_this4.formData.sendScene || []).join(','),
            showStartTime: _this4.formatDateTime(_this4.formData.dateRange[0]),
            showEndTime: _this4.formatDateTime(_this4.formData.dateRange[1]),
            showPlatform: (_this4.formData.showPlatform || []).join(','),
            showImage: _this4.formData.showImage ? _this4.formData.showImage.name || _this4.formData.showImage : '',
            isEnable: _this4.formData.isEnable,
            isShow: _this4.formData.isShow,
            isVip: _this4.formData.isVip,
            isAddQy: _this4.formData.isAddQy,
            isSaleOrder: _this4.formData.isSaleOrder,
            isNewPeopleCoupon: _this4.formData.isNewPeopleCoupon,
            vipGrade: (_this4.formData.vipGrade || []).join(','),
            vipGradeRadio: _this4.formData.vipGradeRadio,
            userType: _this4.formData.userType,
            shopIds: (_this4.formData.selectedStores || []).map(function (s) {
              return s.id;
            }).join(','),
            // 分组类型相关字段
            cdpGrpType: _this4.formData.cdpGrpType,
            cdpGrpId: _this4.formData.cdpGrpId,
            // 滑屏相关字段
            sliderBackgroundColor: _this4.formData.sliderBackgroundColor,
            sliderTextColor: _this4.formData.sliderTextColor,
            sliderLoadColor: _this4.formData.sliderLoadColor,
            sliderScheme: _this4.formData.sliderScheme,
            sliderImage: _this4.formData.sliderImage,
            recommendContentSub: _this4.formData.recommendContentSub
          };

          // 调用API保存数据
          (0, _popupConfig.saveOrUpdatePopupConfig)(submitData).then(function (response) {
            var action = _this4.isEdit ? '编辑' : '添加';
            _this4.$message.success("".concat(action, "\u6210\u529F"));
            console.log('保存成功:', response);
            // 保存成功后关闭标签页
            _this4.$emit('saved');
            _this4.$emit('cancel');
          }).catch(function (error) {
            console.error('保存失败:', error);
            _this4.$message.error('保存失败');
          });
        } else {
          _this4.$message.error('请完善表单信息');
          return false;
        }
      });
    },
    // 启用/禁用弹窗
    handleEnableToggle: function handleEnableToggle() {
      var _this5 = this;
      if (!this.isEdit || !this.editId) {
        this.$message.warning('请先保存弹窗配置');
        return;
      }

      // 调用启用/禁用API
      (0, _popupConfig.enablePopupConfig)(this.editId).then(function (response) {
        _this5.$message.success('操作成功');
        // 更新表单中的启用状态
        _this5.formData.isEnable = !_this5.formData.isEnable;
        console.log('启用/禁用成功:', response);
      }).catch(function (error) {
        console.error('启用/禁用失败:', error);
        _this5.$message.error('操作失败');
        // 恢复开关状态
        _this5.formData.isEnable = !_this5.formData.isEnable;
      });
    },
    // 处理CDP分组类型变化
    handleCdpGrpTypeChange: function handleCdpGrpTypeChange(value) {
      // 清空之前选择的分组
      this.formData.cdpGrpId = null;
      this.cdpGroupOptions = [];

      // 如果选择了分组类型，则查询对应的分组列表
      if (value !== 0) {
        this.queryCdpGroupList('');
      }
    },
    // 查询CDP分组或消费行为信息
    queryCdpGroupList: function () {
      var _queryCdpGroupList2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee4(query) {
        var response, _t4;
        return regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (!(this.formData.cdpGrpType === 0)) {
                _context4.next = 1;
                break;
              }
              this.cdpGroupOptions = [];
              return _context4.abrupt("return");
            case 1:
              _context4.prev = 1;
              this.cdpGroupLoading = true;
              _context4.next = 2;
              return (0, _popupConfig.queryCdpGroupList)({
                type: this.formData.cdpGrpType,
                name: query
              });
            case 2:
              response = _context4.sent;
              if (response.code === 200) {
                this.cdpGroupOptions = response.data.map(function (item) {
                  return {
                    value: item.id,
                    label: item.name
                  };
                });
              } else {
                this.$message.error('查询分组列表失败: ' + (response.message || '未知错误'));
              }
              _context4.next = 4;
              break;
            case 3:
              _context4.prev = 3;
              _t4 = _context4["catch"](1);
              console.error('查询分组列表错误:', _t4);
              this.$message.error('查询分组列表失败: ' + (_t4.message || '网络错误'));
            case 4:
              _context4.prev = 4;
              this.cdpGroupLoading = false;
              return _context4.finish(4);
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[1, 3, 4, 5]]);
      }));
      function queryCdpGroupList(_x) {
        return _queryCdpGroupList2.apply(this, arguments);
      }
      return queryCdpGroupList;
    }(),
    // 取消操作
    handleCancel: function handleCancel() {
      this.$emit('cancel');
    }
  }
};